/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_61149940"]'><cube-button primary disabled>置灰态</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_61149940"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_61149940"}
  /** script content **/
  require("./btn-primary-disabled.mpx.js?isComponent&outputPath=components%2Fbtn-primary-disabled61149940%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-primary-disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-primary-disabled61149940%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_61149940"],
    ctorType: "component",
    outputPath: "components/btn-primary-disabled61149940/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>